import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "svx_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((p, qty = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.product_id === p.product_id);
      if (i >= 0) {
        const next = [...prev];
        next[i] = { ...next[i], qty: next[i].qty + qty };
        return next;
      }
      return [...prev, { product_id: p.product_id, product_code: p.product_code, name: p.name, image: p.image, qty }];
    });
  }, []);

  const setQty = useCallback((pid, qty) => {
    setItems((prev) => prev.map((x) => (x.product_id === pid ? { ...x, qty: Math.max(1, qty) } : x)));
  }, []);
  const remove = useCallback((pid) => setItems((prev) => prev.filter((x) => x.product_id !== pid)), []);
  const clear = useCallback(() => setItems([]), []);
  const count = items.reduce((s, x) => s + x.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};
